import { apiClient } from './api-client';
import { ReviewEligibilityRequest, ReviewEligibilityResponse } from '@/types/review-types';

export class ReviewEligibilityService {
  /**
   * Check if a user can review a booking
   */
  static async checkReviewEligibility(bookingId: string): Promise<ReviewEligibilityResponse> {
    const response = await apiClient.get<ReviewEligibilityResponse>(
      `/bookings/${bookingId}/review-eligibility`
    );
    return response.data;
  }

  /**
   * Check if a booking is completed and eligible for reviews
   */
  static isBookingCompleted(booking: any): boolean {
    return booking.status === 'completed';
  }

  /**
   * Check if a booking's end date has passed (for auto-completion check)
   */
  static hasBookingEnded(booking: any): boolean {
    const endDate = new Date(booking.endDate);
    const now = new Date();
    return endDate < now;
  }

  /**
   * Calculate days remaining for review submission
   */
  static calculateDaysRemaining(deadline: string): number {
    const deadlineDate = new Date(deadline);
    const now = new Date();
    const diffTime = deadlineDate.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
  }

  /**
   * Format deadline for display
   */
  static formatDeadline(deadline: string): string {
    const deadlineDate = new Date(deadline);
    return deadlineDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  /**
   * Check if review deadline has expired
   */
  static isReviewDeadlineExpired(deadline: string): boolean {
    const deadlineDate = new Date(deadline);
    const now = new Date();
    return now > deadlineDate;
  }
}